export default __webpack_public_path__ + "static/media/22.33d3590c.mp3";